import React from 'react';
import {faCheckCircle} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {i18n} from '~/i18n';

export const SaveToast = () => (
  <div>
    <FontAwesomeIcon
      style={{color: '#0da700'}}
      icon={faCheckCircle}
    />
    {i18n('globals.saved')}
  </div>
);
